import React from 'react';
import Header from './shared/Header';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
import { getRandomColor } from '../utils/colors';
const SaturdayCritiqueGroupPage = () => {
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-526">
      <Header data-id="element-527" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-528">
        {/* Mobile Layout */}
        <div className="md:hidden w-full max-w-2xl mx-auto" data-id="element-529">
          <h1 className="text-4xl font-bold mb-8 leading-tight" data-id="element-530">
            Saturday Critique Group 1
          </h1>

          <div className="text-base mb-8" data-id="element-531">
            <div className="font-bold mb-2" data-id="element-532">Dates:</div>
            <div data-id="element-533">Starts 20th June, 2026</div>
            <div data-id="element-534">Six Months, Meets Every Four Weeks</div>
            <div className="mb-4" data-id="element-535">Saturday from 9am - 11:30am EST</div>

            <div data-id="element-536">Six Group Sessions & One 30-minute One-on-One Session</div>
            <div className="mb-4" data-id="element-537">
              (20th June, 18th July, 15th August, 12th September, 10th October,
              7th November)
            </div>

            <div className="mb-1" data-id="element-538">
              <a href="https://www.paypal.com/ncp/payment/S2AB34WLEEV62" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#2563eb';
            }} data-id="element-539">
                SOLD OUT
              </a>
            </div>
            <div className="italic mb-4" data-id="element-540">
              * Please email{' '}
              <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#333333';
            }} data-id="element-541">
                mm@madeleinemorlet.com
              </a>{' '}
              if you are interested in joining Critique Group 2
            </div>

            <div className="font-bold mb-2" data-id="element-542">Location:</div>
            <div data-id="element-543">All sessions will take place over Zoom.</div>
            <div className="mb-4" data-id="element-544">
              Class recordings and any assignments will be shared via email.
            </div>

            <div data-id="element-545">Fee: $600 USD</div>
            <div className="mb-4" data-id="element-546">Refunds up to 30 days before the event.</div>

            <div data-id="element-547">Critique group limited to six attendees.</div>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/3ohKfEppVhBKFKp4Pg9jGM/03_MorletMadeleine_Bougainvillea.jpg" alt="Pink bougainvillea flowers" className="w-full h-auto mb-8" data-id="element-548" />

          <div className="text-base leading-relaxed space-y-4 mb-8" data-id="element-549">
            <div className="font-bold mb-2" data-id="element-550">Critique Group 1:</div>
            <p data-id="element-551">
              This new critique group offers a sustained and intimate structure
              for photographers who have an established practice and are looking
              for support as they continue developing ongoing projects or plan
              to begin new ones. The aim is to make meaningful work and build
              momentum alongside a thoughtful cohort of fellow artists.
              Participants can expect to present work monthly, and to be
              provided with (optional) writing exercises and inspiring
              photography prompts for between sessions.
            </p>
            <p data-id="element-552">
              Taking cues from the Iowa Writers' Workshop, participants will
              present their work for discussion without explanation, allowing
              them to 'see' it as others do. All group members will submit their
              images by the Wednesday prior to our sessions, giving them the
              opportunity to review one another's work in advance – and to
              arrive ready to offer generous and constructive feedback.
            </p>
            <p data-id="element-553">
              At the close of the six months, each participant will have a
              dedicated thirty-minute one-on-one with the instructor to reflect
              on their project's development and discuss its next steps.
            </p>
          </div>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-554" />

          <div className="text-base leading-relaxed" data-id="element-555">
            <div className="font-bold mb-2" data-id="element-556">Instructor:</div>
            <p data-id="element-557">
              Madeleine Morlet is a British-American photographer based in
              London. Her teaching centers on the narrative potential of
              photography and the photobook form, informed by her background in
              filmmaking and creative writing. She combines editorial feedback
              with practical strategy to help students both refine their vision
              and sustain creative practices, guiding them toward publication.
              An award-winning photographer recognised by institutions including
              PhotoVogue and the Lucie Foundation, she brings both professional
              experience and artistic insight into the classroom.
            </p>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-row w-full max-w-6xl mx-auto gap-12" data-id="element-558">
          <div className="w-full md:w-1/2 flex flex-col gap-8" data-id="element-559">
            <img src="https://cdn.magicpatterns.com/uploads/3ohKfEppVhBKFKp4Pg9jGM/03_MorletMadeleine_Bougainvillea.jpg" alt="Pink bougainvillea flowers" className="w-full h-auto" data-id="element-560" />

            <div className="flex-1 flex flex-col justify-end" data-id="element-561">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-562" />

              <div className="text-base leading-relaxed" data-id="element-563">
                <div className="font-bold mb-2" data-id="element-564">Instructor:</div>
                <p data-id="element-565">
                  Madeleine Morlet is a British-American photographer based in
                  London. Her teaching centers on the narrative potential of
                  photography and the photobook form, informed by her background
                  in filmmaking and creative writing. She combines editorial
                  feedback with practical strategy to help students both refine
                  their vision and sustain creative practices, guiding them
                  toward publication. An award-winning photographer recognised
                  by institutions including PhotoVogue and the Lucie Foundation,
                  she brings both professional experience and artistic insight
                  into the classroom.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-566">
            <div className="max-w-2xl" data-id="element-567">
              <h1 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-568">
                Saturday Critique Group 1
              </h1>

              <div className="text-base mb-8" data-id="element-569">
                <div className="font-bold mb-2" data-id="element-570">Dates:</div>
                <div data-id="element-571">Starts 20th June, 2026</div>
                <div data-id="element-572">Six Months, Meets Every Four Weeks</div>
                <div className="mb-4" data-id="element-573">Saturday from 9am - 11:30am EST</div>

                <div data-id="element-574">Six Group Sessions & One 30-minute One-on-One Session</div>
                <div className="mb-4" data-id="element-575">
                  (20th June, 18th July, 15th August, 12th September, 10th
                  October, 7th November)
                </div>

                <div className="mb-1" data-id="element-576">
                  <a href="https://www.paypal.com/ncp/payment/S2AB34WLEEV62" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#2563eb';
                }} data-id="element-577">
                    SOLD OUT
                  </a>
                </div>
                <div className="italic mb-4" data-id="element-578">
                  * Please email{' '}
                  <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-579">
                    mm@madeleinemorlet.com
                  </a>{' '}
                  if you are interested in joining Critique Group 2
                </div>

                <div className="font-bold mb-2" data-id="element-580">Location:</div>
                <div data-id="element-581">All sessions will take place over Zoom.</div>
                <div className="mb-4" data-id="element-582">
                  Class recordings and any assignments will be shared via email.
                </div>

                <div data-id="element-583">Fee: $600 USD</div>
                <div className="mb-4" data-id="element-584">
                  Refunds up to 30 days before the event.
                </div>

                <div data-id="element-585">Critique group limited to six attendees.</div>
              </div>

              <div className="text-base leading-relaxed space-y-4" data-id="element-586">
                <div className="font-bold mb-2" data-id="element-587">Critique Group 1:</div>
                <p data-id="element-588">
                  This new critique group offers a sustained and intimate
                  structure for photographers who have an established practice
                  and are looking for support as they continue developing
                  ongoing projects or plan to begin new ones. The aim is to make
                  meaningful work and build momentum alongside a thoughtful
                  cohort of fellow artists. Participants can expect to present
                  work monthly, and to be provided with (optional) writing
                  exercises and inspiring photography prompts for between
                  sessions.
                </p>
                <p data-id="element-589">
                  Taking cues from the Iowa Writers' Workshop, participants will
                  present their work for discussion without explanation,
                  allowing them to 'see' it as others do. All group members will
                  submit their images by the Wednesday prior to our sessions,
                  giving them the opportunity to review one another's work in
                  advance – and to arrive ready to offer generous and
                  constructive feedback.
                </p>
                <p data-id="element-590">
                  At the close of the six months, each participant will have a
                  dedicated thirty-minute one-on-one with the instructor to
                  reflect on their project's development and discuss its next
                  steps.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default SaturdayCritiqueGroupPage;